import React from 'react'
import { IconButton } from '@material-ui/core'
import GetAppIcon from '@material-ui/icons/GetApp'
import { Card, DonutChart, Text } from '@tremor/react'

const data = [
  { name: 'Usuarios nuevos', value: 27 },
  { name: 'Usuarios recurrentes', value: 73 },
]

const montserratStyle = { fontFamily: 'Montserrat, sans-serif', color: '#1E1E1E' }

const downloadCSV = () => {
  const csvRows = [['Tipo', 'Porcentaje'], ...data.map(row => [row.name, row.value])]
  const csvContent = csvRows.map(e => e.join(',')).join('\n')
  const blob = new Blob([csvContent], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = url
  a.download = 'usuarios_nuevos_vs_recurrentes.csv'
  a.click()
  URL.revokeObjectURL(url)
}

export const NewVsReturning = () => (
  <Card className="p-8">
    <div className="flex flex-row justify-between items-start mb-2">
      <Text className="text-lg font-bold" style={montserratStyle}>
        Usuarios nuevos vs. usuarios recurrentes
      </Text>
      <IconButton className="ml-2" aria-label="download" onClick={downloadCSV}>
        <GetAppIcon />
      </IconButton>
    </div>
    <div className="flex flex-row items-center justify-between mt-4">
      <div style={{ width: 260, height: 260 }}>
        <DonutChart data={data} category="value" index="name" colors={['#56D39D', '#26342E']} />
      </div>
      <div className="flex flex-col gap-6 ml-8">
        <div className="flex items-center gap-2">
          <span
            style={{
              width: 8,
              height: 40,
              background: '#56D39D',
              borderRadius: 4,
              display: 'inline-block',
            }}
          />
          <div>
            <span className="text-2xl font-extrabold" style={montserratStyle}>
              27%
            </span>
            <div className="text-base" style={montserratStyle}>
              Usuarios nuevos
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span
            style={{
              width: 8,
              height: 40,
              background: '#26342E',
              borderRadius: 4,
              display: 'inline-block',
            }}
          />
          <div>
            <span className="text-2xl font-extrabold" style={montserratStyle}>
              73%
            </span>
            <div className="text-base" style={montserratStyle}>
              Usuarios recurrentes
            </div>
          </div>
        </div>
      </div>
    </div>
  </Card>
)
